import script from "./TopActions.vue?vue&type=script&setup=true&lang=js"
export * from "./TopActions.vue?vue&type=script&setup=true&lang=js"

import "./TopActions.vue?vue&type=style&index=0&id=a09768c8&lang=scss&scoped=true"
script.__scopeId = "data-v-a09768c8"

export default script